import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-944dcb02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topban" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zhengque" }, "正确答案为ABD")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xijun" }, null, -1))
const _hoisted_4 = { id: "about2" }
const _hoisted_5 = { class: "xuxian" }
const _hoisted_6 = { class: "zjz" }
const _hoisted_7 = { class: "tubiao" }
const _hoisted_8 = { class: "fuhe" }
const _hoisted_9 = { class: "fuzabox1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topback" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tubiao" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "swperList"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h20" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xijun2" }, null, -1))
const _hoisted_15 = { id: "about2" }
const _hoisted_16 = { class: "xuxian2" }
const _hoisted_17 = { class: "zjz" }
const _hoisted_18 = { class: "tubiao" }
const _hoisted_19 = { class: "fuhe3" }
const _hoisted_20 = { class: "fuzabox" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topback" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tubiao" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "swperList"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chanshu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "chanshu1" }, " 1.中华医学会皮肤性病学分会免疫学组,特应性皮炎协作研究中心. 中华皮肤科杂志,2020,53(2):81-88 "),
  /*#__PURE__*/_createElementVNode("div", { class: "chanshu2" }, " 2.中华医学会皮肤性病学分会免疫学组, 等 . 中华皮肤科杂志, 2021, 54(11) : 937-942. ")
], -1))
const _hoisted_25 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_image, {
                  width: "6.84rem",
                  height: ".52rem",
                  src: require('../assets/zhangjianzhong.png')
                }, null, 8, ["src"]),
                _createVNode(_component_van_image, {
                  width: "8.4667rem",
                  height: "4.1867rem",
                  src: require('../assets/miaoshu.png')
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_van_image, {
                    width: "5.12rem",
                    height: ".8rem",
                    "margin-top": ".1333rem",
                    src: require('../assets/fuhe1.png')
                  }, null, 8, ["src"])
                ])
              ])
            ])
          ]),
          _hoisted_10,
          _hoisted_11,
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_van_image, {
                  width: "7.9467rem",
                  height: "3.04rem",
                  src: require('../assets/fuza.png')
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_van_image, {
                width: "7.2rem",
                height: ".8133rem",
                "margin-top": ".1333rem",
                src: require('../assets/jiaobiao2.png')
              }, null, 8, ["src"])
            ])
          ]),
          _hoisted_21,
          _hoisted_22,
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_24
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_van_image, {
            onClick: $options.jiancha,
            width: "6.1067rem",
            height: "1.1467rem",
            src: require('../assets/tige.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 2 })
  ], 64))
}